import { render, staticRenderFns } from "./Onboard.vue?vue&type=template&id=ce7381a0"
import script from "./Onboard.vue?vue&type=script&lang=ts"
export * from "./Onboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports